<template>
  <v-container>
    <v-form ref="basicDetails" name="basicDetails">
      <v-row class="mt-5">
        <v-col cols="12" md="6">
          <label class="required"> First Name</label>
          <v-text-field
            v-model="beneficiary.fname"
            class=""
            :rules="FieldRequired('First Name')"
            placeholder="First Name"
            required
            dense
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label class="required">Last Name</label>
          <v-text-field
            v-model="beneficiary.lname"
            placeholder="Last Name"
            class=""
            required
            dense
            :rules="FieldRequired('Last Name')"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <label label-for="input-gender" class="required">Nationality</label>
          <v-autocomplete
            placeholder="Nationality"
            dense
            :rules="FieldRequired('Nationality')"
            v-model="beneficiary.nationality"
            :items="nationality_options"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label class="required">ID Type</label>
          <v-autocomplete
            v-model="beneficiary.id_type"
            placeholder="ID Type"
            :items="idtypes"
            outlined
            :rules="FieldRequired('ID Type')"
            required
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label class="required">ID Number </label>
          <v-text-field
            placeholder="ID Number"
            dense
            v-model="beneficiary.id_number"
            :rules="FieldRequired('ID Number')"
            outlined
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="6"
          v-if="beneficiary.id_type != 'Mykad' && beneficiary.id_type != 'Mypr'"
        >
          <label class="required">Issue Date</label>
          <v-text-field
            v-model="beneficiary.issue_date"
            placeholder="Isuue Date"
            dense
            required
            :rules="FieldRequired('Issue Date')"
            outlined
            type="date"
            :max="currentDate"
            :error-messages="
              issueError ? 'Issue Date must less than today' : ''
            "
            :error="issueError"
            @change="ValidateIssue"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          v-if="beneficiary.id_type != 'Mykad' && beneficiary.id_type != 'Mypr'"
        >
          <label class="required">Expiry Date</label>
          <v-text-field
            v-model="beneficiary.expiry_date"
            placeholder="Expiry Date"
            dense
            outlined
            required
            :rules="FieldRequired('Expiry Date')"
            :min="currentDate"
            :error-messages="
              expiryError ? 'Expiry Date must grater than today' : ''
            "
            :error="expiryError"
            @change="ValidateExpiry"
            type="date"
          />
        </v-col>
        <v-col cols="12" md="6">
          <label class="required">Date of Birth</label>
          <!-- <v-text-field
            v-model="beneficiary.dob"
            :rules="dobValidations"
            type="date"
            :max="maxDate"
            dense
            class="text_field"
            outlined
          ></v-text-field> -->
          <v-menu
            ref="dobmenu"
            v-model="dobmenu"
            :close-on-content-click="false"
            lazy
            transition="scale-transition"
            :offset-x="true"
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="beneficiary.dob"
                :rules="FieldRequired('DOB')"
                persistent-hint
                clearable
                v-on="on"
                type="date"
                dense
                @change="ValidateAge"
                :error-messages="isDobError ? $t('dob_errormessage') : ''"
                :error="isDobError"
                :min="minDate"
                :max="maxDate"
                outlined
              >
              </v-text-field>
            </template>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
       
        <v-col cols="12" md="6">
          <label class="required">Address</label>
          <v-text-field
            class=""
            placeholder="Address"
            required
            v-model="beneficiary.address"
            :rules="FieldRequired('Address')"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label label-for="input-gender">Gender</label>
          <v-autocomplete
            id="input-gender"
            placeholder="Gender"
            :items="genderOptions"
            v-model="beneficiary.gender"
            class=""
            outlined
            dense
          ></v-autocomplete>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <label class="required">Postal Code</label>
          <v-text-field
            v-model="beneficiary.postalCode"
            placeholder="Postal Code"
            type="number"
            hide-spin-buttons
            v-mask="'#####'"
            outlined
            dense
            :rules="FieldNumbRequired('Postal Code')"
            class=""
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label class="required">Occupation</label>
          <v-autocomplete
            :items="occupation_options"
            v-model="beneficiary.occupation"
            placeholder="Occupation"
            outlined
            :rules="FieldRequired('Occupation')"
            required
            dense
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <label description="Optional"> E-mail </label>
          <v-text-field
            placeholder="Email"
            class="mb-3"
            type="email"
            dense
            v-model="beneficiary.email"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label description="Optional" class="required"> Phone Number </label>
          <vue-phone-number-input
            default-country-code="MY"
            v-model="beneficiary.phone"
            :rules="FieldRequired('Phone Number')"
            @update="onChangeNumber"
            :error="!isValidNumber"
            class="mb-3"
            required
          />
          <!-- <div style="height: 10px"></div> -->
        </v-col>

      
       

        <!--<v-col cols="12" md="6" v-if="!kycStatus">
          <label>{{ $t("IDLastPage") }}</label>
          <v-file-input
            v-model="user_details.last_page"
            :disabled="disableValues || disableBystatus"
            dense
            accept="image/png, image/jpeg, image/bmp"
            :placeholder="$t('idtype_last_page_placeholder')"
            :show-size="1000"
            outlined
            ref="idlastfile"
            required
            prepend-icon=""
            @change="fileUpload($event, 'BACK_PAGE')"
          >
            <template v-slot:append>
              <v-icon
                aria-hidden="false"
                class="color-primary"
                @click="openIdlast"
              >
                mdi-cloud-upload
              </v-icon>
            </template>

            <template v-slot:append-outer>
              <v-img
                v-if="backPageUrl"
                class="ml-1"
                max-height="40"
                max-width="50"
                :src="backPageUrl"
                @click="handleImageViewer(backPageUrl)"
              />
            </template>
          </v-file-input>
        </v-col> -->

       <v-col cols="12" md="6">
          <label :class="beneficiary.id_type === 'Passport' ? 'required' : ''"
            >Location</label
          >
          <v-autocomplete
            v-model="beneficiary.issue_location"
            :rules="
              beneficiary.id_type === 'Passport'
                ? FieldRequired('Location')
                : ''
            "
            :items="country_options"
            placeholder="Location"
            :disabled="disableIssueLoc"
            dense
            outlined
            requi red
          />
        </v-col>

       
        <v-col cols="12" md="6">
          <label class="required">ID First Page</label>
          <v-file-input
            v-model="beneficiary.first_page"
            :rules="FieldRequired('ID First Page')"
            dense
            accept="image/png, image/jpeg, image/bmp"
            placeholder="ID First Page"
            outlined
            ref="idfirstfile"
            required
            prepend-icon=""
            @click:clear="handleFileClear"
            @change="fileUpload($event, 'FRONT_PAGE')"
          >
            <template v-slot:append>
              <v-icon
                aria-hidden="false"
                class="color-primary"
                @click="openIdfirst"
              >
                mdi-cloud-upload
              </v-icon>
            </template>

            <template v-slot:append-outer>
              <v-img
                v-if="frontPageUrl"
                class="ml-1"
                max-height="40"
                max-width="50"
                :src="frontPageUrl"
                @click="handleImageViewer(frontPageUrl)"
              />
            </template>
          </v-file-input>
        </v-col>
      </v-row>
    </v-form>
    <!-- <v-col cols="12" md="12">
      <v-btn
        class="float-left mt-5 px-5 btn-primary-outlined text-capitalize"
        outlined
        @click="onClickBack"
        ><v-icon dark left>mdi-arrow-left</v-icon> {{ $t("backLabel") }}</v-btn
      >
      <v-btn
        class="float-right mt-5 px-5 btn-primary-outlined text-capitalize"
        outlined
        @click="onClickNext"
        >{{ $t("next") }} <v-icon dark right>mdi-arrow-right</v-icon></v-btn>
    </v-col> -->
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '350',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </v-container>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { findDatePrevious } from "../../../utils/helper";
import imageViewer from "../../tools/imageViewer.vue";
import { FieldRequired, FieldNumbRequired } from "@/utils/validation.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
import commonService from "@/services/AgentCommonService/commonService.js";
export default {
  name: "BasicDetails",
  data: () => ({
    FieldRequired,
    FieldNumbRequired,
    filterNumberInput,
    currentDate: new Date().toJSON().split("T")[0],
    expiryError: false,
    issueError: false,
    maxDate: null,
    minDate: null,
    nationality_options: [],
    occupation_options: [],
    nationality_obj: [],
    occupation_obj: [],
    isValidNumber: false,
    relation_options: [],
    genderOptions: [
      { text: "Male", value: "Male" },
      { text: "Female", value: "Female" },
    ],
    isSubmitted: false,
    beneficiary: {
      fname: "",
      lname: "",
      phone: "",
      email: "",
      nationality: "",
      nationality_code: "",
      postalCode: "",
      occupation: "",
      occupation_code: "",
      dob: null,
      gender: "",
      id_type: "",
      issue_date: null,
      issue_location: "",
      id_number: "",
      address: "",
      expiry_date: null,
      first_page: null,
    },
    country_options: [],
    isDobError: false,
    dobmenu: false,
    idtypes: [],
    idtype_objs: [],
    disableIssueLoc: false,
    frontPageUrl: null,
    isImageViewer: false,
    imageViewerUrl: "",
  }),
  props: {
    beneficiaryDetails: {
      type: Object,
    },
  },
  components: {
    VuePhoneNumberInput,
    imageViewer,
  },
  computed: {},
  validations() {
    return {};
  },
  mounted() {
    this.getidtypes();
    this.getOccupation();
    this.getNationalityList();
    this.getCountryList();
    this.maxDate = new Date().toJSON().slice(0, 10);
    console.log("Ddd", this.maxDate);
    this.maxDate = findDatePrevious(new Date(), 18);
    this.minDate = findDatePrevious(new Date(), 70);
  },
  watch: {
    "beneficiary.id_type"(val) {
      this.idtype_objs.map((i) => {
        if (val === i.value) {
          this.beneficiary.id_type_code = i.value_code;
        }
      });
      if (val == "Mykad" || val == "Mypr") {
        this.beneficiary.issue_location = "Malaysia";
        this.disableIssueLoc = true;
      } else {
        this.beneficiary.issue_location = "";
        this.disableIssueLoc = false;
      }
    },
    "beneficiary.nationality"(newVal) {
      if (newVal) {
        this.nationality_obj.map((ele) => {
          if (ele.nationality === newVal) {
            this.beneficiary.nationality_code = ele.iso_alpha3;
          }
        });
      }
    },
    "beneficiary.occupation"(newVal) {
      console.log(newVal);
      if (newVal) {
        this.occupation_obj.map((ele) => {
          if (ele.value === newVal) {
            this.beneficiary.occupation_code = ele.value_code;
          }
        });
      }
    },
    beneficiaryDetails: {
      immediate: true,
      handler(val) {
        if (val.id_type) {
          this.beneficiary = val;
        }
      },
    },
  },
  methods: {
    handleFileClear() {
      this.frontPageUrl = "";
    },
    ValidateExpiry(value, e) {
      console.log(value, e);
      if (!value) {
        this.expiryError = false;
      } else {
        this.expiryError = !(value > this.currentDate);
      }
    },
    ValidateIssue(value, e) {
      console.log(value, e);
      if (!value) {
        this.issueError = false;
      } else {
        this.issueError = !(value < this.currentDate);
      }
    },
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },
    async fileUpload(fileObject, doc_type) {
      const imageurl = await URL.createObjectURL(fileObject);
      if (doc_type == "FRONT_PAGE") this.frontPageUrl = imageurl;
    },
    openIdfirst() {
      this.$refs.idfirstfile.$el.querySelector("input").click();
    },
    async getidtypes() {
      try {
        const responseData = await commonService.getparameterdropdowns(
          "DOC",
          this.$route.query.user_type_code
        );
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((idtype) => {
            this.idtypes.push(idtype.value);
            this.idtype_objs.push(idtype);
          });
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getNationalityList() {
      try {
        const responseData = await commonService.getCountryBirthList();
        if (responseData.data.status_code === 200) {
          this.nationality_options = await responseData.data.data.map(
            (i) => i.nationality
          );
          this.nationality_obj = responseData.data.data;
        }

        console.log("countrys", responseData);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },
    async getOccupation() {
      try {
        const responseData = await commonService.getparameterdropdowns(
          "OCC",
          this.$route.query.user_type_code
        );
        if (responseData.data.status_code === 200) {
          this.occupation_options = await responseData.data.data.map(
            (i) => i.value
          );
          this.occupation_obj = responseData.data.data;
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    onChangeNumber(e) {
      console.log("validity", e.isValid);
      this.isValidNumber = e.isValid;
    },
    onClickBack() {
      this.$emit("onClickBack");
    },
    onClickNext() {
      this.isSubmitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      let tempNumb = this.beneficiary.phone.replace(/ /g, "");
      this.beneficiary.phone = tempNumb;
      this.$emit("onNextClick", { basicDetails: this.beneficiary });
    },
    async getCountryList() {
      try {
        const responseData = await commonService.getCountryBirthList();
        if (responseData.data.status_code === 200) {
          this.country_options = responseData.data.data.map(
            (i) => i.country_name
          );
        }

        console.log("countrys", responseData);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },

    ValidateAge(value, e) {
      console.log(value, e);

      if (!value) {
        this.isDobError = false;
      } else {
        this.isDobError = !(value <= this.maxDate && value >= this.minDate);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.invalid-feedback-name {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}

.required:after {
  content: " *";
  color: red;
}
</style>
